import React from 'react';
import { Step, StepperPageContextType } from '../components/Layout';

export const StepperPageContext = React.createContext<StepperPageContextType>({
  pageTitle: null,
  setPageTitle: (title: string) => null,
  steps: [],
  setSteps: (steps: Array<Step>) => null,
  onBack: () => null,
  onNext: () => null,
  activeStep: null,
  activeStepIndex: 0,
  onComplete: () => null,
});
